import React, { useEffect, useState } from "react";
import { Space } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { deleteUser, userListAction } from "../../actions/admin";
import SideDrawer from "../../components/Comman/Drawer/SideDrawer";
import ConfirmDeleteModal from "../../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import { useNavigate } from "react-router-dom";
import { leaderUserListAction } from "../../actions/user";
import { formatMobileNumber, showRole } from "../../utils/comman";
import Filter from "../../components/Comman/Filter";

const UserList = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const user = useSelector((state: any) => state?.Auth?.user);
  const searchItem = useSelector((state: any) => state?.General?.searchValue);
  const roleId = user?.user?.roleId;
  const [isOrganizationModalOpen, setIsOrganizationModalOpen] =
    useState<boolean>(false);
  const [deleteModelVisible, setDeleteModelVisible] = useState<boolean>(false);
  const [selectedOrganization, setSelectedOrganization] = useState<any>(null);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [searchValue, setSearchValue] = useState(null);

  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  //for global search using redux 

  // useEffect(() => {
  //   fetchUserList({
  //     page: pagination.current || 1,
  //     limit: pagination.pageSize || 10,
  //     search: searchItem,
  //   });
  // }, [searchItem]);

  const fetchUserList = (params = {}) => {
    setLoading(true);
    const data = {
      ...params,
    };

    if ([2, 3].includes(roleId)) {
      dispatch(
        leaderUserListAction(data, (resp: any) => {
          setLoading(false);
          if (resp?.status === 200) {
            setData(resp.data || []);
            setPagination({
              ...pagination,
              total: resp.pagination?.totalItems,
              current: resp.pagination?.currentPage,
              pageSize: resp.pagination?.pageSize,
            });
          }
        })
      );
    } else {
      dispatch(
        userListAction(data, (resp: any) => {
          setLoading(false);
          if (resp?.status === 200) {
            setData(resp.data || []);
            setPagination({
              ...pagination,
              total: resp.pagination?.totalItems,
              current: resp.pagination?.currentPage,
              pageSize: resp.pagination?.pageSize,
            });
          }
        })
      );
    }
  };

  useEffect(() => {
    fetchUserList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(searchValue?.length && { search: searchValue }), // Pass the search value
    });
  }, [handleRefresh]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter)?.length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    fetchUserList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(searchValue?.length && { search: searchValue }), // Pass the search value

      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handleEditClick = (record: any) => {
    handleIsOrganizationModelOpen();
    setSelectedOrganization(record); // Store the selected organization's data
  };

  const handleIsOrganizationModelOpen: any = () => {
    setIsOrganizationModalOpen(!isOrganizationModalOpen);
  };

  const handleDeleteModel = (id?: number) => {
    if (id) setSelectedUserId(id); // Store the selected user ID
    setDeleteModelVisible(!deleteModelVisible);
  };


  // This function handles the search functionality
  const handleSearch = (value: string) => {
    setSearchValue(value); 
    fetchUserList({
      page: 1,
      limit: pagination.pageSize || 10,
      ...(value?.length ? { search: value } : {}), // include only if non-empty
      ...(sortConfig.field && sortConfig.order
        ? {
            sort: sortConfig.field,
            order: sortConfig.order,
          }
        : {}),
    });
  };
  
              
  const handleUserDeletion = () => {
    setLoading(true); // Show loading indicator before making the API call
    dispatch(
      deleteUser(selectedUserId, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          // User deleted successfully, handle UI update if needed
          handleDeleteModel();
        } else {
          handleDeleteModel();
        }
      })
    );
  };

  const columns = [
    {
      title: "User Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Email address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
      render: (data) => formatMobileNumber(data),
    },
    ...(roleId === 1
      ? [
          {
            title: "Org Assignments",
            dataIndex: "organizationAssignment",
            key: "organizationAssignment",
            render: (orgs: any[]) =>
              orgs && orgs?.length > 0
                ? orgs.map((org) => org.organization?.shortCode).join(", ")
                : "-",
          },
        ]
      : []),
    {
      title: `Assigned Data Elements`,
      dataIndex: "totalDataElementsCount",
      key: "totalDataElementsCount",
    },

    {
      title: `Role`,
      dataIndex: "roleId",
      key: "roleId",
      render: (roleId) => showRole[roleId] || "-",
    },

    // {
    //   title: "Status",
    //   dataIndex: "isActive",
    //   key: "isActive",
    //   render: (text: any) => {
    //     const isActive = text === true; // Assuming "Yes" means it's budgeted
    //     return (
    //       <Tag
    //         color={isActive ? "green" : "red"}
    //         style={{ color: "white", fontWeight: "bold" }}
    //       >
    //         {isActive ? "Active" : "InActive"}
    //       </Tag>
    //     );
    //   },
    // },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          {roleId === 1 && (
            <span
              style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
            >
              <EditOutlined
                onClick={() => {
                  handleEditClick(record);
                }}
              />
            </span>
          )}
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EyeOutlined
              onClick={() =>
                roleId === 2
                  ? navigate(`/leader/view/user/${record?.id}`)
                  : roleId === 3
                  ? navigate(`/controller/view/user/${record?.id}`)
                  : navigate(`/admin/view/user/${record?.id}`)
              }
            />
          </span>
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            {roleId === 1 && (
              <DeleteOutlined onClick={() => handleDeleteModel(record?.id)} />
            )}
          </span>
        </Space>
      ),
    },
  ];



  return (
    <div>
      {/* <Header /> */}
    <div className="flex justify-between items-center mb-2">
    <h1 className="text-3xl font-bold text-left mb-6 text-white">Users</h1>
    {/* <Filter searchParam="Initial Value"/>  */}
    {[1].includes(roleId) && (
  <Filter
    name="Search Items"
    handleSearch={handleSearch}
    setSearchValue={setSearchValue}
    searchValue={searchValue}
  />
)}

    </div>
        {/* <h1 className="text-3xl font-bold text-left mb-6 text-white">Users</h1> */}
      <div className="table-col">
        <DataTable
          columns={columns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
      <SideDrawer
        open={isOrganizationModalOpen}
        onClose={handleIsOrganizationModelOpen}
        type={"user"}
        organizationData={selectedOrganization} // Pass only selected record
      />
      {deleteModelVisible && (
        <ConfirmDeleteModal
          handleConfirmDeleteModel={handleDeleteModel}
          type="delete"
          handleModelFunction={handleUserDeletion}
        />
      )}
    </div>
  );
};

export default UserList;
